// Decode HTML entities so fitment values like "AR1K11001 &amp; Above" display and match as "& Above".
function decodeHtmlEntities(str){str=String(str==null?"":str);if(str.indexOf("&")===-1)return str;try{var el=document.createElement("textarea");el.innerHTML=str;return el.value;}catch(e){return str;}}
// Searchable Dropdown Functionality - Combobox Style
(function() {
  // Add CSS for searchable dropdowns
  const style = document.createElement('style');
  style.textContent = `
    .searchable-select-wrapper {
      position: relative;
      width: 100%;
    }
    .searchable-select-wrapper > select {
      position: absolute !important;
      opacity: 0 !important;
      pointer-events: none !important;
      height: 0 !important;
      width: 0 !important;
    }
    .searchable-select-input {
      width: 100%;
      padding: 12px 35px 12px 15px;
      font-size: 15px;
      height: 52px;
      border: 1px solid #ddd;
      border-radius: 3px;
      background: #fff url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>") no-repeat;
      background-position: calc(100% - 12px) center;
      cursor: pointer;
      box-sizing: border-box;
      outline: none;
    }
    .searchable-select-input:focus {
      border-color: #999;
    }
    .searchable-select-input.disabled {
      background-color: #f5f5f5;
      color: #999;
      cursor: not-allowed;
    }
    .searchable-select-input::placeholder {
      color: #999;
    }
    .searchable-select-dropdown {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background: #fff;
      border: 1px solid #ddd;
      border-top: none;
      border-radius: 0 0 3px 3px;
      max-height: 250px;
      overflow-y: auto;
      z-index: 9999;
      display: none;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    }
    .searchable-select-dropdown.open {
      display: block;
    }
    .searchable-select-option {
      padding: 10px 15px;
      cursor: pointer;
      font-size: 14px;
    }
    .searchable-select-option:hover,
    .searchable-select-option.highlighted {
      background: #f0f0f0;
    }
    .searchable-select-option.selected {
      background: #e8f4fc;
      font-weight: 500;
    }
    .searchable-select-no-results {
      padding: 10px 15px;
      color: #999;
      font-size: 14px;
    }
  `;
  document.head.appendChild(style);

  // Function to make a select searchable
  window.makeSelectSearchable = function(select) {
    if (!select || select.dataset.searchable === 'true') return;
    select.dataset.searchable = 'true';

    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'searchable-select-wrapper';
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);

    // Get placeholder text
    const placeholder = select.options[0]?.text || 'Select...';

    // Create input element (replaces display)
    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'searchable-select-input';
    input.placeholder = placeholder;
    input.value = select.selectedIndex > 0 ? decodeHtmlEntities(select.options[select.selectedIndex].text) : '';
    if (select.disabled) {
      input.classList.add('disabled');
      input.disabled = true;
    }
    wrapper.appendChild(input);

    // Create dropdown
    const dropdown = document.createElement('div');
    dropdown.className = 'searchable-select-dropdown';
    wrapper.appendChild(dropdown);

    let isOpen = false;
    let openedOnFocus = false; // suppress the click that fires right after a focus-open
    let highlightedIndex = -1;
    let userCleared = false; // Track if user cleared the field

    // Render options
    function renderOptions(filter = '') {
      const filterLower = filter.toLowerCase();
      let html = '';
      let hasResults = false;
      let firstMatchIndex = -1;
      
      for (let i = 0; i < select.options.length; i++) {
        const opt = select.options[i];
        if (opt.value === '' && i === 0) continue; // Skip placeholder
        
        const text = decodeHtmlEntities(opt.text);
        if (filterLower && !text.toLowerCase().includes(filterLower)) continue;
        
        if (firstMatchIndex === -1) firstMatchIndex = i;
        hasResults = true;
        const selectedClass = opt.selected ? 'selected' : '';
        const highlightedClass = i === highlightedIndex ? 'highlighted' : '';
        html += `<div class="searchable-select-option ${selectedClass} ${highlightedClass}" data-value="${opt.value}" data-index="${i}">${text}</div>`;
      }
      
      if (!hasResults) {
        html = '<div class="searchable-select-no-results">No results found</div>';
      }
      
      dropdown.innerHTML = html;
      return firstMatchIndex;
    }

    // Open dropdown
    function openDropdown() {
      if (select.disabled) return;
      isOpen = true;
      dropdown.classList.add('open');
      // Always show all options when opening
      renderOptions('');
      input.select(); // Select all text for easy replacement
    }

    // Close dropdown
    function closeDropdown(restoreValue = true) {
      isOpen = false;
      openedOnFocus = false;
      dropdown.classList.remove('open');
      highlightedIndex = -1;
      if (restoreValue) {
        if (input.value.trim() === '') {
          // Field left empty: commit the clear so the select + downstream cascade update
          // and it can't be resurrected from the stale select value.
          if (select.value !== '') {
            select.value = '';
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          // Snap the text back to the actual selected option's label.
          input.value = select.selectedIndex > 0 ? decodeHtmlEntities(select.options[select.selectedIndex].text) : '';
        }
      }
      userCleared = false;
    }

    // Select option
    function selectOption(index) {
      select.selectedIndex = index;
      input.value = select.options[index]?.text || '';
      userCleared = false;
      closeDropdown(false);
      
      // Trigger change event
      const event = new Event('change', { bubbles: true });
      select.dispatchEvent(event);
    }

    // Update input when select changes externally
    function updateFromSelect() {
      // Don't resurrect a field the user just cleared (the select may still hold the old value).
      if (!userCleared) {
        input.value = select.selectedIndex > 0 ? decodeHtmlEntities(select.options[select.selectedIndex].text) : '';
      }
      input.placeholder = select.options[0]?.text || 'Select...';
      if (select.disabled) {
        input.classList.add('disabled');
        input.disabled = true;
      } else {
        input.classList.remove('disabled');
        input.disabled = false;
      }
    }

    // Event listeners
    input.addEventListener('focus', () => {
      userCleared = false;
      openedOnFocus = true;
      openDropdown();
    });

    input.addEventListener('click', () => {
      // The click that fires immediately after a focus-open must not toggle it closed
      if (openedOnFocus) {
        openedOnFocus = false;
        return;
      }
      // Tapping the field toggles the dropdown (fixes mobile: tap again to close)
      userCleared = false;
      if (isOpen) {
        closeDropdown();
        input.blur();
      } else {
        openDropdown();
      }
    });

    input.addEventListener('input', (e) => {
      if (!isOpen) openDropdown();
      highlightedIndex = -1;
      // If field is empty, user cleared it
      if (e.target.value === '') {
        userCleared = true;
      }
      renderOptions(e.target.value);
    });

    input.addEventListener('keydown', (e) => {
      // Handle backspace/delete - if field becomes empty, mark as cleared
      if ((e.key === 'Backspace' || e.key === 'Delete')) {
        setTimeout(() => {
          if (input.value === '') {
            userCleared = true;
            renderOptions('');
          }
        }, 0);
      }
      if (e.key === 'Escape') {
        closeDropdown();
        input.blur();
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        const options = dropdown.querySelectorAll('.searchable-select-option');
        if (highlightedIndex >= 0 && options[highlightedIndex]) {
          selectOption(parseInt(options[highlightedIndex].dataset.index));
        } else if (options.length > 0) {
          selectOption(parseInt(options[0].dataset.index));
        }
      }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const options = dropdown.querySelectorAll('.searchable-select-option');
        if (options.length > 0) {
          highlightedIndex = Math.min(highlightedIndex + 1, options.length - 1);
          options.forEach((opt, i) => opt.classList.toggle('highlighted', i === highlightedIndex));
          options[highlightedIndex]?.scrollIntoView({ block: 'nearest' });
        }
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        const options = dropdown.querySelectorAll('.searchable-select-option');
        if (options.length > 0) {
          highlightedIndex = Math.max(highlightedIndex - 1, 0);
          options.forEach((opt, i) => opt.classList.toggle('highlighted', i === highlightedIndex));
          options[highlightedIndex]?.scrollIntoView({ block: 'nearest' });
        }
      }
    });

    dropdown.addEventListener('mousedown', (e) => {
      e.preventDefault(); // Prevent input blur
      const option = e.target.closest('.searchable-select-option');
      if (option) {
        selectOption(parseInt(option.dataset.index));
      }
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) {
        closeDropdown();
      }
    });

    // Observe select for changes (disabled state, options)
    const observer = new MutationObserver(() => {
      updateFromSelect();
    });
    observer.observe(select, { attributes: true, childList: true, subtree: true });

    // Store reference for updates
    select._searchableUpdate = updateFromSelect;

    return wrapper;
  };

  // Make all selects in a container searchable
  window.makeSelectsSearchable = function(container) {
    const selects = container.querySelectorAll('select');
    selects.forEach(select => window.makeSelectSearchable(select));
  };
})();

if (!customElements.get('make-type-model-variant-search')) {
  customElements.define(
    'make-type-model-variant-search',
    class VariantSearch extends HTMLElement {
      constructor() {
        super();

        // Category selector
        this.categoryFilter = this.querySelector('.select__category_data');
        
        // Heavy-Duty Machinery fields
        this.makeFilter = this.querySelector('.select__make_data');
        this.typeFilter = this.querySelector('.select__type_data');
        this.submodelFilter = this.querySelector('.select__submodel_data');
        this.modelFilter = this.querySelector('.select__model_data');
        this.variantFilter = this.querySelector('.select__variant_data');
        this.variant2Filter = this.querySelector('.select__variant2_data');
        
        // Automotive/Trucks fields
        this.yearFilter = this.querySelector('.select__year_data');
        this.autoMakeFilter = this.querySelector('.select__auto_make_data');
        this.autoModelFilter = this.querySelector('.select__auto_model_data');
        this.trimFilter = this.querySelector('.select__trim_data');
        this.engineFilter = this.querySelector('.select__engine_data');
        
        // Get all filter elements by class
        this.heavyDutyFilters = this.querySelectorAll('.heavy-duty-filter');
        this.automotiveFilters = this.querySelectorAll('.automotive-filter');
        this.submodelWrapper = this.querySelector('.submodel-wrapper');
        this.variant2Wrapper = this.querySelector('.variant2-wrapper');
        
        this.searchURL = this.querySelector('.search__url');

        // State
        this.selectedCategory = 'Heavy-Duty Machinery';
        this.selectedMake = null;
        this.selectedType = null;
        this.selectedSubmodel = null;
        this.selectedModel = null;
        this.selectedVariant = null;
        this.selectedVariant2 = null;
        this.selectedYear = null;
        this.selectedAutoMake = null;
        this.selectedAutoModel = null;
        this.selectedTrim = null;
        this.selectedEngine = null;

        // Data storage
        this.heavyDutyEntries = [];
        this.truckEntries = [];      // matrix2
        this.automotiveEntries = []; // matrix3

        // Bind events
        this.categoryFilter?.addEventListener('change', e => this.onCategoryChange(e));
        this.makeFilter?.addEventListener('change', e => this.onMakeChange(e));
        this.typeFilter?.addEventListener('change', e => this.onTypeChange(e));
        this.submodelFilter?.addEventListener('change', e => this.onSubmodelChange(e));
        this.modelFilter?.addEventListener('change', e => this.onModelChange(e));
        this.variantFilter?.addEventListener('change', e => this.onVariantChange(e));
        this.variant2Filter?.addEventListener('change', e => this.onVariant2Change(e));
        this.yearFilter?.addEventListener('change', e => this.onYearChange(e));
        this.autoMakeFilter?.addEventListener('change', e => this.onAutoMakeChange(e));
        this.autoModelFilter?.addEventListener('change', e => this.onAutoModelChange(e));
        this.trimFilter?.addEventListener('change', e => this.onTrimChange(e));
        this.engineFilter?.addEventListener('change', e => this.onEngineChange(e));

        // Load data and initialize
        this.loadCompatibilityData();
        
        // Show Heavy-Duty by default
        this.showHeavyDutyFilters();
        this.populateMakeOptions();
        this.updateSearchURL();
        
        // Initialize searchable dropdowns
        setTimeout(() => {
          if (window.makeSelectSearchable) {
            window.makeSelectSearchable(this.categoryFilter);
            window.makeSelectSearchable(this.makeFilter);
            window.makeSelectSearchable(this.typeFilter);
            window.makeSelectSearchable(this.submodelFilter);
            window.makeSelectSearchable(this.modelFilter);
            window.makeSelectSearchable(this.variantFilter);
            window.makeSelectSearchable(this.variant2Filter);
            window.makeSelectSearchable(this.yearFilter);
            window.makeSelectSearchable(this.autoMakeFilter);
            window.makeSelectSearchable(this.autoModelFilter);
            window.makeSelectSearchable(this.trimFilter);
            window.makeSelectSearchable(this.engineFilter);
          }
        }, 100);
      }

      showHeavyDutyFilters() {
        this.heavyDutyFilters.forEach(el => el.style.display = '');
        this.automotiveFilters.forEach(el => el.style.display = 'none');
        if (this.submodelWrapper) this.submodelWrapper.style.display = 'none';
        if (this.variant2Wrapper) this.variant2Wrapper.style.display = 'none';
      }

      showAutomotiveFilters() {
        this.heavyDutyFilters.forEach(el => el.style.display = 'none');
        this.automotiveFilters.forEach(el => el.style.display = '');
      }

      loadCompatibilityData() {
        // 1) Metafield data — always loaded. Kits rely on metafields, and this seeds the
        //    filter instantly so it works before the network call returns.
        this.loadFromMetafields();

        // 2) Live SKUs + CSV data, fetched in parallel, then merged.
        const FITMENT_URL = 'https://unrivaled-zuccutto-bdbd4b.netlify.app/.netlify/functions/fitment';
        const DKEY = 'ufFitmentDropdown_v1', DTTL = 15 * 60 * 1000;
        const loadDropdown = () => {
          try {
            const c = sessionStorage.getItem(DKEY);
            const ts = parseInt(sessionStorage.getItem(DKEY + '_ts') || '0', 10);
            if (c && (Date.now() - ts) < DTTL) { const d = JSON.parse(c); if (d) return Promise.resolve(d); }
          } catch (e) {}
          return fetch(FITMENT_URL, { headers: { 'Accept': 'application/json' } })
            .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
            .then(d => {
              try { sessionStorage.setItem(DKEY, JSON.stringify(d)); sessionStorage.setItem(DKEY + '_ts', String(Date.now())); } catch (e) {}
              return d;
            });
        };

        Promise.all([
          this.loadLiveSkus(),
          loadDropdown()
        ])
          .then(([liveSkus, data]) => {
            this.liveSkus = liveSkus;
            this.mergeCsvData(data);
            // Only refresh the open dropdowns if the user hasn't started selecting yet
            const heavyStarted = this.selectedMake || this.selectedType || this.selectedModel || this.selectedVariant;
            const autoStarted = this.selectedYear || this.selectedAutoMake || this.selectedAutoModel;
            if (!heavyStarted && !autoStarted) this.refreshInitialOptions();
          })
          .catch(err => {
            console.error('Fitment data load failed (filter using metafields only):', err);
          });
      }

      // Build the set of live product SKUs (lowercased). Tries the inline list the section
      // prints; if that's missing/empty (e.g. cached page or other page), falls back to
      // Shopify's product feed, which is available on every page. Returns a Promise<Set>.
      loadLiveSkus() {
        // Set of live product SKUs. Cache it — crawling /products.json across ~12 pages on every
        // load is a big source of the lag. Shared with the sidebar so they reuse each other's crawl.
        // Only cache a COMPLETE crawl; if a page fails after retries, fail open (empty set -> show all
        // makes) instead of caching a partial set that would hide valid machines.
        const KEY = 'ufLiveSkus_v2', TTL = 15 * 60 * 1000;
        try {
          const c = sessionStorage.getItem(KEY);
          const ts = parseInt(sessionStorage.getItem(KEY + '_ts') || '0', 10);
          if (c && (Date.now() - ts) < TTL) { const arr = JSON.parse(c); if (arr && arr.length) return Promise.resolve(new Set(arr)); }
        } catch (e) {}
        const set = new Set();
        const wait = ms => new Promise(r => setTimeout(r, ms));
        const getPage = (page, attempt = 0) => fetch('/products.json?limit=250&page=' + page, { headers: { 'Accept': 'application/json' } })
          .then(r => { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
          .catch(() => attempt < 3 ? wait(300 * (attempt + 1)).then(() => getPage(page, attempt + 1)) : { _failed: true });
        let failed = false;
        const loop = (page) => getPage(page).then(d => {
          if (d && d._failed) { failed = true; return; }
          const list = (d && d.products) || [];
          list.forEach(p => (p.variants || []).forEach(v => {
            const t = (v.sku || '').trim().toLowerCase();
            if (t) set.add(t);
          }));
          if (list.length === 250 && page < 40) return loop(page + 1);
        });
        return loop(1).then(() => {
          if (failed) return new Set(); // incomplete crawl -> show all makes, don't cache
          try { sessionStorage.setItem(KEY, JSON.stringify([...set])); sessionStorage.setItem(KEY + '_ts', String(Date.now())); } catch (e) {}
          return set;
        });
      }

      // Merge CSV rows into the metafield-loaded data, deduped. Only CSV machines whose
      // SKU maps to a live product are kept. Metafields are left intact (kits unaffected).
      mergeCsvData(data) {
        const live = this.liveSkus || new Set();
        const filterByLive = live.size > 0; // if we couldn't read live SKUs, don't filter
        if (!filterByLive) console.warn('[fitment] Live SKU list empty — showing ALL CSV machines (could not verify live products).');
        const isLive = e => !filterByLive ||
          (Array.isArray(e.skus) && e.skus.some(s => live.has(String(s).trim().toLowerCase())));

        const dedupePush = (arr, rows, keyFn) => {
          const seen = new Set(arr.map(keyFn));
          rows.forEach(row => {
            const k = keyFn(row);
            if (!seen.has(k)) { seen.add(k); arr.push(row); }
          });
        };

        dedupePush(
          this.heavyDutyEntries,
          (data.heavyDuty || []).filter(isLive).map(e => ({
            make: e.make || '', type: e.type || '', submodel: e.submodel || '',
            model: e.model || '', variant: e.variant || '', variant2: e.variant2 || ''
          })),
          e => [e.make, e.type, e.submodel, e.model, e.variant, e.variant2].join('||')
        );

        dedupePush(
          this.automotiveEntries,
          (data.automotive || []).filter(isLive).map(e => ({
            year: e.year || '', make: e.make || '', model: e.model || '',
            trim: e.trim || '', engine: e.engine || ''
          })),
          e => [e.year, e.make, e.model, e.trim, e.engine].join('||')
        );
      }

      // Re-populate the first dropdown for the current category once data has loaded
      refreshInitialOptions() {
        if (this.selectedCategory === 'Heavy-Duty Machinery' || !this.selectedCategory) {
          this.populateMakeOptions();
        } else if (this.selectedCategory === 'Automotive' || this.selectedCategory === 'Trucks') {
          this.populateYearOptions();
        }
      }

      // Fallback source: original metafield <script> tags
      loadFromMetafields() {
        // Load Heavy-Duty data (matrix1)
        const matrix1Scripts = document.querySelectorAll('.product-compatability-matrix');
        this.heavyDutyEntries = [];
        matrix1Scripts.forEach(script => {
          const raw = script.textContent.trim();
          if (!raw) return;
          raw.split('\n').forEach(line => {
            const fields = line.split('|').map(s => s.trim());
            if (fields.length >= 4) {
              this.heavyDutyEntries.push({
                make: fields[0] || '', type: fields[1] || '', submodel: fields[2] || '',
                model: fields[3] || '', variant: fields[4] || '', variant2: fields[5] || ''
              });
            }
          });
        });

        // Load Trucks data (matrix2)
        const matrix2Scripts = document.querySelectorAll('.product-compatability-matrix2');
        this.truckEntries = [];
        matrix2Scripts.forEach(script => {
          const raw = script.textContent.trim();
          if (!raw) return;
          raw.split('\n').forEach(line => {
            const fields = line.split('|').map(s => s.trim());
            if (fields.length >= 3) {
              this.truckEntries.push({
                year: fields[0] || '', make: fields[1] || '', model: fields[2] || '',
                trim: fields[3] || '', engine: fields[4] || ''
              });
            }
          });
        });

        // Load Automotive data (matrix3)
        const matrix3Scripts = document.querySelectorAll('.product-compatability-matrix3');
        this.automotiveEntries = [];
        matrix3Scripts.forEach(script => {
          const raw = script.textContent.trim();
          if (!raw) return;
          raw.split('\n').forEach(line => {
            const fields = line.split('|').map(s => s.trim());
            if (fields.length >= 3) {
              this.automotiveEntries.push({
                year: fields[0] || '', make: fields[1] || '', model: fields[2] || '',
                trim: fields[3] || '', engine: fields[4] || ''
              });
            }
          });
        });
      }

      // Get the right dataset based on category
      getVehicleData() {
        if (this.selectedCategory === 'Trucks') {
          return this.truckEntries;
        } else if (this.selectedCategory === 'Automotive') {
          return this.automotiveEntries;
        }
        return [];
      }

      uniqueSorted(arr) {
        return [...new Set(arr.filter(v => v && v !== ''))].sort();
      }

      clearDropdown(dropdown, placeholder) {
        if (!dropdown) return;
        dropdown.innerHTML = `<option value="">${placeholder}</option>`;
        dropdown.disabled = true;
      }

      populateDropdown(dropdown, options, placeholder) {
        if (!dropdown) return;
        let html = `<option value="">${placeholder}</option>`;
        options.forEach(opt => {
          html += `<option value="${opt}">${opt}</option>`;
        });
        dropdown.innerHTML = html;
        dropdown.disabled = false;
      }

      // Hide + reset the Variant 2 dropdown (called whenever an upstream selection changes)
      hideVariant2() {
        this.selectedVariant2 = null;
        if (this.variant2Filter) this.clearDropdown(this.variant2Filter, 'Select Variant 2');
        if (this.variant2Wrapper) {
          this.variant2Wrapper.style.display = 'none';
          this.variant2Wrapper.classList.remove('show');
        }
      }

      // ==========================================
      // CATEGORY CHANGE
      // ==========================================
      onCategoryChange(e) {
        this.selectedCategory = e.target.value || 'Heavy-Duty Machinery';
        
        this.resetHeavyDutySelections();
        this.resetAutomotiveSelections();
        
        if (this.selectedCategory === 'Heavy-Duty Machinery' || !this.selectedCategory) {
          this.showHeavyDutyFilters();
          this.populateMakeOptions();
        } else if (this.selectedCategory === 'Automotive' || this.selectedCategory === 'Trucks') {
          this.showAutomotiveFilters();
          this.populateYearOptions();
        }
        
        this.updateSearchURL();
      }

      resetHeavyDutySelections() {
        this.selectedMake = null;
        this.selectedType = null;
        this.selectedSubmodel = null;
        this.selectedModel = null;
        this.selectedVariant = null;
        
        this.clearDropdown(this.makeFilter, 'Select Make');
        this.clearDropdown(this.typeFilter, 'Select Type');
        this.clearDropdown(this.submodelFilter, 'Select Sub-Model');
        this.clearDropdown(this.modelFilter, 'Select Model');
        this.clearDropdown(this.variantFilter, 'Select Variant');
        
        if (this.submodelWrapper) {
          this.submodelWrapper.style.display = 'none';
          this.submodelWrapper.classList.remove('show');
        }
        this.hideVariant2();
        if (this.makeFilter) this.makeFilter.disabled = false;
      }

      resetAutomotiveSelections() {
        this.selectedYear = null;
        this.selectedAutoMake = null;
        this.selectedAutoModel = null;
        this.selectedTrim = null;
        this.selectedEngine = null;
        
        this.clearDropdown(this.yearFilter, 'Select Year');
        this.clearDropdown(this.autoMakeFilter, 'Select Make');
        this.clearDropdown(this.autoModelFilter, 'Select Model');
        this.clearDropdown(this.trimFilter, 'Select Trim');
        this.clearDropdown(this.engineFilter, 'Select Engine');
        
        if (this.yearFilter) this.yearFilter.disabled = false;
      }

      // ==========================================
      // HEAVY-DUTY MACHINERY FLOW
      // ==========================================
      populateMakeOptions() {
        const makes = this.uniqueSorted(this.heavyDutyEntries.map(e => e.make));
        this.populateDropdown(this.makeFilter, makes, 'Select Make');
        this.clearDropdown(this.typeFilter, 'Select Type');
        this.clearDropdown(this.submodelFilter, 'Select Sub-Model');
        this.clearDropdown(this.modelFilter, 'Select Model');
        this.clearDropdown(this.variantFilter, 'Select Variant');
        if (this.submodelWrapper) {
          this.submodelWrapper.style.display = 'none';
          this.submodelWrapper.classList.remove('show');
        }
        this.hideVariant2();
      }

      // Populate the Model dropdown from the current make, optionally narrowed by type/submodel,
      // so Model is choosable right after Make (without first choosing Type).
      populateModelsFor(opts) {
        opts = opts || {};
        const models = this.uniqueSorted(
          this.heavyDutyEntries.filter(en =>
            en.make === this.selectedMake &&
            (!opts.type || en.type === opts.type) &&
            (!opts.submodel || en.submodel === opts.submodel)
          ).map(en => en.model)
        );
        this.populateDropdown(this.modelFilter, models, 'Select Model');
      }

      // Show/populate the Sub-Model field for a type (hide when the type has none).
      syncSubmodelField(type) {
        const submodels = this.uniqueSorted(
          this.heavyDutyEntries.filter(en => en.make === this.selectedMake && en.type === type).map(en => en.submodel)
        );
        if (submodels.length > 0) {
          if (this.submodelWrapper) { this.submodelWrapper.style.display = ''; this.submodelWrapper.classList.add('show'); }
          this.populateDropdown(this.submodelFilter, submodels, 'Select Sub-Model');
          return true;
        }
        if (this.submodelWrapper) { this.submodelWrapper.style.display = 'none'; this.submodelWrapper.classList.remove('show'); }
        this.clearDropdown(this.submodelFilter, 'Select Sub-Model');
        return false;
      }

      onMakeChange(e) {
        this.selectedMake = e.target.value || null;
        this.selectedType = null;
        this.selectedSubmodel = null;
        this.selectedModel = null;
        this.selectedVariant = null;

        this.clearDropdown(this.typeFilter, 'Select Type');
        this.clearDropdown(this.submodelFilter, 'Select Sub-Model');
        this.clearDropdown(this.modelFilter, 'Select Model');
        this.clearDropdown(this.variantFilter, 'Select Variant');
        if (this.submodelWrapper) {
          this.submodelWrapper.style.display = 'none';
          this.submodelWrapper.classList.remove('show');
        }
        this.hideVariant2();

        if (!this.selectedMake) {
          this.populateMakeOptions();
          this.updateSearchURL();
          return;
        }

        const types = this.uniqueSorted(
          this.heavyDutyEntries.filter(en => en.make === this.selectedMake).map(en => en.type)
        );
        this.populateDropdown(this.typeFilter, types, 'Select Type');
        // Both Type and Model are choosable: populate Model with every model for this make.
        this.populateModelsFor({});
        this.updateSearchURL();
      }

      onTypeChange(e) {
        this.selectedType = e.target.value || null;
        this.selectedSubmodel = null;
        this.selectedModel = null;
        this.selectedVariant = null;
        this.clearDropdown(this.variantFilter, 'Select Variant');
        this.hideVariant2();

        if (!this.selectedMake) { this.clearDropdown(this.modelFilter, 'Select Model'); this.updateSearchURL(); return; }

        if (!this.selectedType) {
          // Type cleared: restore the full model list for the make.
          if (this.submodelWrapper) { this.submodelWrapper.style.display = 'none'; this.submodelWrapper.classList.remove('show'); }
          this.clearDropdown(this.submodelFilter, 'Select Sub-Model');
          this.populateModelsFor({});
          this.updateSearchURL();
          return;
        }

        // Sub-Model is an optional refinement; Model stays choosable, narrowed to the type.
        this.syncSubmodelField(this.selectedType);
        this.populateModelsFor({ type: this.selectedType });
        this.updateSearchURL();
      }

      onSubmodelChange(e) {
        this.selectedSubmodel = e.target.value || null;
        this.selectedModel = null;
        this.selectedVariant = null;
        this.clearDropdown(this.variantFilter, 'Select Variant');
        this.hideVariant2();
        this.populateModelsFor({ type: this.selectedType, submodel: this.selectedSubmodel || null });
        this.updateSearchURL();
      }

      onModelChange(e) {
        this.selectedModel = e.target.value || null;
        this.selectedVariant = null;

        if (!this.selectedModel) {
          this.clearDropdown(this.variantFilter, 'Select Variant');
          this.hideVariant2();
          this.updateSearchURL();
          return;
        }

        // Back-fill Type (and Sub-Model) from the chosen model when they weren't set.
        let rows = this.heavyDutyEntries.filter(en =>
          en.make === this.selectedMake && en.model === this.selectedModel &&
          (!this.selectedType || en.type === this.selectedType) &&
          (!this.selectedSubmodel || en.submodel === this.selectedSubmodel)
        );
        if (!rows.length) {
          // A previously auto-filled type/submodel no longer fits this model: re-derive cleanly.
          this.selectedType = null; this.selectedSubmodel = null;
          rows = this.heavyDutyEntries.filter(en => en.make === this.selectedMake && en.model === this.selectedModel);
        }
        if (rows.length) {
          const row = rows[0];
          if (!this.selectedType && row.type) {
            this.selectedType = row.type;
            if (this.typeFilter) { this.typeFilter.value = row.type; if (this.typeFilter._searchableUpdate) this.typeFilter._searchableUpdate(); }
            this.syncSubmodelField(row.type);
          }
          if (!this.selectedSubmodel && row.submodel) {
            this.selectedSubmodel = row.submodel;
            if (this.submodelFilter) { this.submodelFilter.value = row.submodel; if (this.submodelFilter._searchableUpdate) this.submodelFilter._searchableUpdate(); }
          }
        }

        let filteredEntries = this.heavyDutyEntries.filter(en =>
          en.make === this.selectedMake &&
          en.type === this.selectedType &&
          en.model === this.selectedModel
        );
        if (this.selectedSubmodel) {
          filteredEntries = filteredEntries.filter(en => en.submodel === this.selectedSubmodel);
        }

        const variants = this.uniqueSorted(filteredEntries.map(en => en.variant));
        if (variants.length) {
          this.populateDropdown(this.variantFilter, variants, 'Select Variant');
        } else {
          this.variantFilter.innerHTML = `<option value="">No Variants Available</option>`;
          this.variantFilter.disabled = true;
        }
        this.hideVariant2();
        this.updateSearchURL();
      }

      onVariantChange(e) {
        this.selectedVariant = e.target.value || null;
        this.selectedVariant2 = null;

        if (!this.selectedVariant) {
          this.hideVariant2();
          this.updateSearchURL();
          return;
        }

        // Find Variant 2 values for the full current selection (mirrors the submodel logic)
        let filtered = this.heavyDutyEntries.filter(en =>
          en.make === this.selectedMake &&
          en.type === this.selectedType &&
          en.model === this.selectedModel &&
          en.variant === this.selectedVariant
        );
        if (this.selectedSubmodel) {
          filtered = filtered.filter(en => en.submodel === this.selectedSubmodel);
        }
        const variant2s = this.uniqueSorted(filtered.map(en => en.variant2));

        if (variant2s.length > 0) {
          if (this.variant2Wrapper) {
            this.variant2Wrapper.style.display = '';
            this.variant2Wrapper.classList.add('show');
          }
          this.populateDropdown(this.variant2Filter, variant2s, 'Select Variant 2');
        } else {
          this.hideVariant2();
        }

        this.updateSearchURL();
      }

      onVariant2Change(e) {
        this.selectedVariant2 = e.target.value || null;
        this.updateSearchURL();
      }

      // ==========================================
      // AUTOMOTIVE / TRUCKS FLOW
      // ==========================================
      populateYearOptions() {
        const data = this.getVehicleData();
        const years = this.uniqueSorted(data.map(e => e.year)).sort((a, b) => b - a);
        this.populateDropdown(this.yearFilter, years, 'Select Year');
        this.clearDropdown(this.autoMakeFilter, 'Select Make');
        this.clearDropdown(this.autoModelFilter, 'Select Model');
        this.clearDropdown(this.trimFilter, 'Select Trim');
        this.clearDropdown(this.engineFilter, 'Select Engine');
      }

      onYearChange(e) {
        this.selectedYear = e.target.value || null;
        this.selectedAutoMake = null;
        this.selectedAutoModel = null;
        this.selectedTrim = null;
        this.selectedEngine = null;

        if (!this.selectedYear) {
          this.populateYearOptions();
          this.updateSearchURL();
          return;
        }

        const data = this.getVehicleData();
        const makes = this.uniqueSorted(
          data.filter(e => e.year === this.selectedYear).map(e => e.make)
        );
        
        this.populateDropdown(this.autoMakeFilter, makes, 'Select Make');
        this.clearDropdown(this.autoModelFilter, 'Select Model');
        this.clearDropdown(this.trimFilter, 'Select Trim');
        this.clearDropdown(this.engineFilter, 'Select Engine');
        this.updateSearchURL();
      }

      onAutoMakeChange(e) {
        this.selectedAutoMake = e.target.value || null;
        this.selectedAutoModel = null;
        this.selectedTrim = null;
        this.selectedEngine = null;

        if (!this.selectedAutoMake) {
          this.clearDropdown(this.autoModelFilter, 'Select Model');
          this.clearDropdown(this.trimFilter, 'Select Trim');
          this.clearDropdown(this.engineFilter, 'Select Engine');
          this.updateSearchURL();
          return;
        }

        const data = this.getVehicleData();
        const models = this.uniqueSorted(
          data.filter(e => e.year === this.selectedYear && e.make === this.selectedAutoMake)
            .map(e => e.model)
        );
        
        this.populateDropdown(this.autoModelFilter, models, 'Select Model');
        this.clearDropdown(this.trimFilter, 'Select Trim');
        this.clearDropdown(this.engineFilter, 'Select Engine');
        this.updateSearchURL();
      }

      onAutoModelChange(e) {
        this.selectedAutoModel = e.target.value || null;
        this.selectedTrim = null;
        this.selectedEngine = null;

        if (!this.selectedAutoModel) {
          this.clearDropdown(this.trimFilter, 'Select Trim');
          this.clearDropdown(this.engineFilter, 'Select Engine');
          this.updateSearchURL();
          return;
        }

        const data = this.getVehicleData();
        const filtered = data.filter(e => 
          e.year === this.selectedYear && 
          e.make === this.selectedAutoMake && 
          e.model === this.selectedAutoModel
        );

        const trims = this.uniqueSorted(filtered.map(e => e.trim));
        
        if (trims.length > 0) {
          this.populateDropdown(this.trimFilter, trims, 'Select Trim');
        } else {
          this.trimFilter.innerHTML = `<option value="">No Trims Available</option>`;
          this.trimFilter.disabled = true;
        }

        // Also populate engines directly (for cases where trim is empty)
        const engines = this.uniqueSorted(filtered.map(e => e.engine));
        if (engines.length > 0) {
          this.populateDropdown(this.engineFilter, engines, 'Select Engine');
        } else {
          this.engineFilter.innerHTML = `<option value="">No Engines Available</option>`;
          this.engineFilter.disabled = true;
        }

        this.updateSearchURL();
      }

      onTrimChange(e) {
        this.selectedTrim = e.target.value || null;
        this.selectedEngine = null;

        const data = this.getVehicleData();
        let filtered = data.filter(e => 
          e.year === this.selectedYear && 
          e.make === this.selectedAutoMake && 
          e.model === this.selectedAutoModel
        );

        // If trim is selected, filter by it
        if (this.selectedTrim) {
          filtered = filtered.filter(e => e.trim === this.selectedTrim);
        }

        const engines = this.uniqueSorted(filtered.map(e => e.engine));
        
        if (engines.length > 0) {
          this.populateDropdown(this.engineFilter, engines, 'Select Engine');
        } else {
          this.engineFilter.innerHTML = `<option value="">No Engines Available</option>`;
          this.engineFilter.disabled = true;
        }

        this.updateSearchURL();
      }

      onEngineChange(e) {
        this.selectedEngine = e.target.value || null;
        this.updateSearchURL();
      }

      // ==========================================
      // URL BUILDING - Allows partial search
      // ==========================================
      updateSearchURL() {
        let url = '/collections/all';
        const params = new URLSearchParams();

        if (this.selectedCategory) {
          params.append('category', this.selectedCategory);
        }

        if (this.selectedCategory === 'Heavy-Duty Machinery' || !this.selectedCategory) {
          // Allow partial search - add whatever is selected
          if (this.selectedMake) params.append('make', this.selectedMake);
          if (this.selectedType) params.append('type', this.selectedType);
          if (this.selectedSubmodel) params.append('submodel', this.selectedSubmodel);
          if (this.selectedModel) params.append('model', this.selectedModel);
          if (this.selectedVariant) params.append('variant', this.selectedVariant);
          if (this.selectedVariant2) params.append('variant2', this.selectedVariant2);
        } else if (this.selectedCategory === 'Automotive' || this.selectedCategory === 'Trucks') {
          // Allow partial search - add whatever is selected
          if (this.selectedYear) params.append('year', this.selectedYear);
          if (this.selectedAutoMake) params.append('make', this.selectedAutoMake);
          if (this.selectedAutoModel) params.append('model', this.selectedAutoModel);
          if (this.selectedTrim) params.append('trim', this.selectedTrim);
          if (this.selectedEngine) params.append('engine', this.selectedEngine);
        }

        if ([...params].length) url += '?' + params.toString();
        this.searchURL.setAttribute('href', url);
      }
    }
  );
}